module.exports = __webpack_public_path__ + "static/media/prize-container-thadinyut-theme.cb33632c.png";